import { render, staticRenderFns } from "./FooterWithDeco.vue?vue&type=template&id=54ded950&scoped=true&"
import script from "./FooterWithDeco.vue?vue&type=script&lang=js&"
export * from "./FooterWithDeco.vue?vue&type=script&lang=js&"
import style0 from "./FooterWithDeco.vue?vue&type=style&index=0&id=54ded950&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ded950",
  null
  
)

export default component.exports